import NullTableRegion from "./NullTableRegion";
import TableRegionChangeEvent from "./TableRegionChangeEvent";
import TableRegion from "./TableRegion";

export default class HoverController {
    constructor() {
        this.hoverRegion = NullTableRegion;
        this.listeners = [];
    }

    addHoverChangeListener(listener) {
        this.listeners.push(listener);
    }

    fireHoverChangeEvent(oldHoverRegion, mouseEvent) {
        var hoverChangeEvent = new TableRegionChangeEvent(oldHoverRegion, this.hoverRegion);
        for (var i = 0; i < this.listeners.length; i++)
            this.listeners[i].call(this.listeners[i], hoverChangeEvent, mouseEvent);
    }

    hover(startCell, endCell, mouseEvent) {
        var oldHoverRegion = this.hoverRegion;
        this.hoverRegion = TableRegion.prototype.createFromCells(startCell, endCell);
        if (!this.hoverRegion.equals(oldHoverRegion))
            this.fireHoverChangeEvent(oldHoverRegion, mouseEvent);
    }

    unhover(mouseEvent) {
        var oldHoverRegion = this.hoverRegion;
        this.hoverRegion = NullTableRegion;
        this.fireHoverChangeEvent(oldHoverRegion, mouseEvent);
    }

    isHovered(cell) {
        return this.hoverRegion.contains(cell.getRow().getRowIdx(), cell.getColIdx());
    }

    getHoverRegion() {
        return this.hoverRegion;
    }
}


// WEBPACK FOOTER //
// ./web/js/table/HoverController.js